<template>
  <section class="section-wrapper grey">
    <v-container class="home-deal-types-container">
      <h3>What kind of financing do you need?</h3>

      <DealTypeGrid @continue="goToQuestionnaire" />
    </v-container>
  </section>
</template>

<script>
import DealTypeGrid from '@/modules/shared/components/DealTypeGrid'

export default {
  name: 'HomeDealTypes',
  components: {
    DealTypeGrid,
  },

  methods: {
    async goToQuestionnaire (selectedTypes) {
      await this.$router.push({
        name: 'ChoosePractice',
        query: { dealType: selectedTypes },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.section-wrapper .container {
  min-height: 300px;

  align-items: stretch;

  @include md {
    align-items: center;
  }
}

h3 {
  margin-bottom: 25px;
  text-align: center;
}
</style>
